
var LicenseType = require('./licenseType');
var HeaderType = require('./headerType');

// this is serialized to/from string  - thus, no functions (they would be lost at deserializing)
var LicenseInfo = {

    create: function() {
        var val = {
            headerType: HeaderType.Hm3,


            state: LicenseType.NoLicense,

            // kept as millis , to allow easy serializing
            expires: Date.now(),

            // mla-274 - differentiate from maintenance expired
            trialExpires: Date.now(),

            cancelled: false,

            // if true, Full license, if false, small stakes
            fullLicense: true,

            userEmail: "",// "dummy@dummy.com",

            isOverMaxVersion: false,

            hasAvailableTrial: false,

            maxVersion: "",

            restrictions: [],
            restrictionsFreemium: [],
        };
        return val;
    },

    copy: function(other) {
        var c = this.create();
        c.headerType = other.headerType;
        c.state = other.state;
        c.expires = other.expires;
        c.trialExpires = other.trialExpires;
        c.fullLicense = other.fullLicense;
        c.userEmail = other.userEmail;
        c.cancelled = other.cancelled;
        c.isOverMaxVersion = other.isOverMaxVersion;
        c.maxVersion = other.maxVersion;
        c.hasAvailableTrial = other.hasAvailableTrial;

        c.restrictions = other.restrictions;
        c.restrictionsFreemium = other.restrictionsFreemium;
        return c;
    }

};

module.exports = LicenseInfo;


// WEBPACK FOOTER //
// ./src/state/licenseInfo.js